import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { DumpDateRange } from '../../types/generated.types';
import { DateHelper } from '../../helpers/date.helper';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';

@Injectable({ providedIn: 'root' })
export class SchedulerDumpApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/scheduler-dump`;
  }

  public async getSize(): Promise<number> {
    return await this.get<number>('size');
  }

  public async getDateRange(): Promise<DumpDateRange> {
    const result = await this.get<DumpDateRange>('date-range');
    ApiConversionHelper.convertDates(result, ['from', 'to']);
    return result;
  }

  public downloadDumps(from?: Date, to?: Date): void {
    const params: string[] = [];
    if (from) {
      params.push(`from=${DateHelper.formatApiDateTime(from)}`);
    }
    if (to) {
      params.push(`to=${DateHelper.formatApiDateTime(to)}`);
    }
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    this.download(queryString);
  }

  public async deleteDumps(): Promise<void> {
    return await this.delete('');
  }
}
